import React, { useState } from "react";
import "./ApprovalCard.css";
import { OpenInBrowser } from "@material-ui/icons";
import { Button, Modal } from "@material-ui/core";
import firebase from "firebase";
import { db } from "../../../../firebase";

const getDate = (t) => {
  if (!t) {
    return null;
  }
  const time = t.toLocaleDateString();
  return time;
};

function ApprovalCard({ data, skillState, relodState }) {
  const [, setRelod] = relodState;
  const [aviliableSkill, setAviliableSkill] = skillState;
  const [showModal, setShowModal] = useState(false);
  const [skill, setSkill] = useState(data.skillCategory);
  const [chooseCategory, setChooseCategory] = useState("");
  const [text, setText] = useState(data.skillCategory);

  //adding skills to DB
  const addSkillHandler = async () => {
    try {
      await db
        .collection("HomePageData")
        .doc("ScreenData")
        .update({
          SkillCategory: firebase.firestore.FieldValue.arrayUnion(text),
        });

      await db.collection("Skills").doc(data.key).update({
        skillCategory: text,
      });
      setAviliableSkill((p) => [...p, text]);
      setSkill(text);
      setShowModal(false);
    } catch (e) {
      console.log(e);
    }
  };

  const changeCategoryHandler = () => {
    setSkill(chooseCategory);
    setShowModal(false);
  };

  const approveHandler = async () => {
    try {
      await db.collection("Skills").doc(data.key).update({
        isApproved: true,
      });
      setRelod((p) => !p);
    } catch (e) {
      console.log(e);
    }
  };

  const rejectHandler = async () => {
    try {
      await db.collection("Skills").doc(data.key).delete();
      setRelod((p) => !p);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div className="skill__card">
        <p>
          <b>Title:</b> {data.title}
        </p>
        <p>
          <b>Description:</b> {data.description}
        </p>
        <p>
          <b>Posted By:</b> {data.name}
        </p>
        <p>
          <b>Posted On:</b> {getDate(data.uploadedDate.toDate())}
        </p>

        {data.mediaURL ? (
          <>
            <b>Image:</b>
            <div className="skill__card__imageContainer">
              <img
                src={data.mediaURL}
                alt=""
                onClick={() => window.open(data.mediaURL, "_blank")}
              />
            </div>
          </>
        ) : null}

        {data.youtubeVideoLink ? (
          <>
            <div className="skill__card__videoContainer">
              <p
                onClick={() => window.open(data.youtubeVideoLink, "_blank")}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  // border: "1px solid black",
                }}
              >
                <b>Video:</b>
                <span style={{ color: "blue", marginLeft: "5px" }}>
                  {data.youtubeVideoLink}
                </span>
                <OpenInBrowser />
              </p>
            </div>
          </>
        ) : null}
        <p>
          <b>Category: </b> {skill}
          {!aviliableSkill.includes(skill) ? (
            <span
              className="approval__newPill"
              onClick={() => setShowModal(true)}
            >
              New
            </span>
          ) : null}
        </p>
        <div className="approval__btns">
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: "10px" }}
            disabled={!aviliableSkill.includes(skill)}
            onClick={approveHandler}
          >
            Approve
          </Button>
          <Button variant="contained" color="primary" onClick={rejectHandler}>
            Reject
          </Button>
        </div>
      </div>

      <Modal open={showModal} onClose={() => setShowModal(false)}>
        <div className="approval__modal">
          <div>
            <p>Option 1: ADD "{skill}" as new Skill Category</p>
            <input
              value={text}
              onChange={(e) =>
                setText(
                  e.target.value.trim().charAt(0).toUpperCase() +
                    e.target.value.trim().substring(1)
                )
              }
            />
            <Button
              variant="contained"
              color="primary"
              style={{ fontSize: "13px", marginLeft: "5px" }}
              onClick={addSkillHandler}
              disabled={aviliableSkill.includes(text) || !text}
            >
              Add Category
            </Button>
          </div>
          <div>
            <p>Option 2: Add under already avaliable categories</p>
            <select
              value={chooseCategory}
              onChange={(e) => setChooseCategory(e.target.value)}
            >
              <option value="" disabled>
                category
              </option>
              {aviliableSkill.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
            <Button
              variant="contained"
              color="primary"
              style={{ fontSize: "13px" }}
              disabled={!chooseCategory}
              onClick={changeCategoryHandler}
            >
              Change category
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ApprovalCard;
